import React from 'react';
import getLodash from 'lodash/get';
import { connect } from 'react-redux';
import { fileHandlerUrl } from '../../../utils/consts/server';
import { ChevronDownIcon, ChevronUpIcon } from '~svg';
import '../../common/dropDown/dropDown.scss';
class CultureDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenOption: false,
      selected: '',
      search: '',
      suggestion: '',
      indexOfOption: 0,
    };
    this.node = React.createRef();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.value &&
      (nextProps.value != this.props.value || !this.state.selected)
    )
      this.findSendValueInDataOfDropDown(
        nextProps.value,
        nextProps.options.data,
      );
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleclick);
    this.findSendValueInDataOfDropDown(this.props.value);
  }
  componentDidUpdate(prevProps, prevState) {
    if (!this.props.value && prevState.selected)
      this.setState({ selected: '' });
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleclick);
  }
  arrayToObject = (array) =>
    array.reduce((obj, item) => {
      obj[item['0']] = item;
      return obj;
    }, {});
  findSendValueInDataOfDropDown = (newValue, data) => {
    if (!data) data = this.props.options.data;
    let { value } = this.props.options;
    let selected = data.filter((item) => {
      return item[value] === newValue;
    });
    if (selected.length > 0) {
      const peopleObject = this.arrayToObject(selected);
      this.setState({ selected: peopleObject['undefined'] });
    }
  };
  onOption = (item) => {
    let selected = item;
    this.setState(
      {
        selected: { returnedValue: selected },
        isOpenOption: false,
        suggestion: '',
      },
      () => {
        this.props.onChange(this.state.selected);
      },
    );
  };
  onChangeInput = (event) => {
    let suggestion = '';
    let phrase = event.target.value;
    let { options, hasChild, language } = this.props;
    let { data, label, isMultiLanguage } = options;
    if (phrase.length) {
      let tmp = data.filter((item) => {
        if (typeof item === 'object') {
          if (hasChild) {
            let lodash = getLodash(item, hasChild);
            return lodash;
          } else if (item[label])
            return isMultiLanguage
              ? item[label][language.name].toLowerCase().indexOf(phrase) === 0
              : item[label].toString().toLowerCase().indexOf(phrase) === 0;
        } else return item[label].indexOf(phrase) === 0;
      });
      if (tmp.length > 0) {
        if (hasChild) {
          let lodash = getLodash(tmp[0], hasChild);
          suggestion = lodash[label].toLowerCase();
        } else if (typeof tmp[0] === 'object')
          suggestion = isMultiLanguage
            ? tmp[0][label][language.name].toLowerCase()
            : tmp[0][label].toString().toLowerCase();
        else suggestion = tmp[0].toLowerCase();
      }
    }
    this.setState({
      search: phrase,
      suggestion,
      indexOfOption: 0,
    });
  };
  renderListOptionShow = (item) => {
    let { label, isMultiLanguage } = this.props.options;
    let { name } = this.props.language;
    if (typeof item[label] === 'object')
      return isMultiLanguage ? item[label][name] : item.label;
    else return getLodash(item, label);
  };
  renderListOption = (search) => {
    let { label } = this.props.options,
      { indexOfOption } = this.state,
      { direction } = this.props;
    return (
      <>
        {search.map((item, index) => {
          if (item && getLodash(item, label) !== null)
            return (
              <div
                key={index}
                onClick={() => {
                  this.onOption(item);
                }}
                onMouseEnter={() => {
                  this.setState({ indexOfOption: index });
                }}
                className={`col px-3 py-3 d-flex flex-start text-black ${
                  direction === 'ltr' ? 'font-small' : 'font-smaller'
                } ${index === search.length ? '' : 'border-bottom'} ${
                  index === indexOfOption ? 'dropDownComponentHover' : ''
                } `}
                style={{ cursor: 'pointer' }}
              >
                {this.renderListOptionShow(item)}
              </div>
            );
        })}
      </>
    );
  };
  findInAllLanguage = (item, label, search) => {
    if (
      item[label]['en'].toLowerCase().indexOf(search.toLowerCase()) > -1 ||
      (item['index'] &&
        item['index'].toString().toLowerCase() === search.toLowerCase())
    )
      return item;
    if (
      item[label]['fa'].toLowerCase().indexOf(search.toLowerCase()) > -1 ||
      (item['index'] &&
        item['index'].toString().toLowerCase() === search.toLowerCase())
    )
      return item;
  };
  renderOption = () => {
    let { isOpenOption, search, selected } = this.state;
    let { hasChild, language, options } = this.props;
    let { label, data, isMultiLanguage } = options;
    let searchData = options.data;
    if (options && hasChild)
      searchData = options.map((item) => {
        return getLodash(item, hasChild);
      });
    //searchData = getChild;
    if (isOpenOption) {
      if (search.length > 0) {
        searchData = data.filter((item) => {
          if (item && item[label])
            return isMultiLanguage
              ? this.findInAllLanguage(item, label, search)
              : item[label]
                  .toString()
                  .toLowerCase()
                  .indexOf(search.toLowerCase()) > -1 ||
                  (item['index'] &&
                    item['index'].toString().toLowerCase() ===
                      search.toLowerCase());
        });
      }
      return (
        <div
          className={
            'w-100 p-0 d-flex flex-column justify-content-between position-absolute bg-white shadow'
          }
          id="cultureOptionList"
          style={{
            color: '#999',
            border: selected ? '1px solid #00c853' : '1px solid #ccc',
            borderTopWidth: '0px',
            borderRadius: '0 0 4px 4px',
            zIndex: 20000,
            maxHeight: '233px',
            overflowY: 'auto',
            width: '90.5%',
          }}
        >
          {searchData && this.renderListOption(searchData)}
        </div>
      );
    } else return null;
  };
  renderLabel = () => {
    let { selected } = this.state,
      { direction } = this.props.language,
      { currentCulture, currentCountryName, cultureMessage } = this.props;
    if (selected) {
      return (
        <div className="col-10 d-flex align-items-center justify-content-start px-2">
          <span
            className={`text-truncate text-third ${
              direction === 'rtl' ? 'font-smaller' : 'font-small'
            }`}
          >{` ${
            direction === 'rtl'
              ? `${cultureMessage} ${selected.returnedValue.name.fa
                  .toString()
                  .substring(0, 23)}`
              : `${selected.returnedValue.code
                  .toString()
                  .toUpperCase()} ${cultureMessage}`
          }`}</span>
        </div>
      );
    } else {
      return (
        <div className="col-10 d-flex align-items-center justify-content-start px-2">
          <span
            className={`text-truncate text-third${
              direction === 'rtl' ? 'fonr-smaller' : 'font-small'
            }`}
          >
            {` ${
              direction === 'rtl'
                ? `${cultureMessage} ${currentCountryName
                    .toString()
                    .substring(0, 23)}`
                : `${currentCulture.toString().toUpperCase()} ${cultureMessage}`
            }`}
          </span>
        </div>
      );
    }
  };
  renderSelectedLabelAndDefaultLabel = () => {
    return (
      <span
        className={`col-12 p-0 d-flex flex-start justify-content-start font-smaller`}
      >
        {this.renderLabel()}
      </span>
    );
  };
  renderSearchAndLabel = () => {
    let { isOpenOption, suggestion } = this.state;
    if (isOpenOption)
      return (
        <div
          className={
            'col p-0 d-flex justify-content-center align-items-center font-smaller'
          }
        >
          {/* <input
            autoComplete="false"
            type="text"
            value={isOpenOption && suggestion}
            className={`d-flex justify-content-end  px-0 py-2 rounded  outline-0 border-0 
            font-smaller
             text-dark`}
            onChange={() => {}}
          /> */}
          <input
            autoComplete="false"
            type="text"
            autoFocus={true}
            onChange={this.onChangeInput}
            className={`w-100 d-flex justify-content-end px-2 rounded  outline-0 border-0 font-smaller text-dark`}
          />
        </div>
      );
    else return this.renderSelectedLabelAndDefaultLabel();
  };
  onClickSelect = () => {
    this.setState((prevState) => ({
      isOpenOption: !prevState.isOpenOption,
      indexOfOption: 0,
      search: '',
    }));
  };
  handleclick = (e) => {
    if (this.node && this.node.contains(e.target)) return;
    else this.setState({ isOpenOption: false });
  };
  openOptionOfDropDownWithKeyPress = (item) => {
    this.setState({ isOpenOption: item, indexOfOption: 0 });
  };
  render() {
    let {
      tabIndex = 0,
      onClick = () => {},
      id,
      name,
      options,
      error,
      currentCulture,
      parentClassName,
      ...rest
    } = this.props;
    let { isOpenOption, indexOfOption } = this.state;
    return (
      <div
        className={'w-100 position-relative'}
        tabIndex={tabIndex}
        id={name}
        onKeyDown={(e) => {
          let optionsDiv = document.getElementById('cultureOptionList');
          if (e.key === 'Enter')
            this.onOption(options.data[this.state.indexOfOption]);
          if (e.key === 'ArrowDown' && isOpenOption === false) {
            this.openOptionOfDropDownWithKeyPress(true);
          } else if (
            e.key === 'ArrowDown' &&
            isOpenOption === true &&
            indexOfOption < options.data.length - 1
          ) {
            this.setState(
              {
                indexOfOption: this.state.indexOfOption + 1,
              },
              () => {
                if (this.state.indexOfOption > 4) {
                  optionsDiv.scrollTop += 50;
                }
              },
            );
          } else if (
            e.key === 'ArrowUp' &&
            isOpenOption === true &&
            indexOfOption > 0
          ) {
            this.setState(
              {
                indexOfOption: this.state.indexOfOption - 1,
              },
              () => {
                optionsDiv.scrollTop -= 50;
              },
            );
          }
        }}
        ref={(event) => (this.node = event)}
        style={{ outline: 'none' }}
      >
        <div
          className={`d-flex flex-column p-3 cursor-pointer border border-third ${
            isOpenOption
              ? 'default-border-top-radius-small'
              : 'default-border-radius-small'
          } ${parentClassName}`}
          onClick={() => {
            this.onClickSelect();
          }}
          style={{
            color: '#999',
            // borderBottomWidth: isOpenOption ? '0px' : '1px',
            borderRadius: isOpenOption ? '4px 4px 0 0' : 4,
            maxHeight: '75px',
            outline: 'none',
          }}
        >
          <div
            className={`col-12 d-flex align-items-center justify-content-around px-1 `}
          >
            <div className="d-flex flex-start align-items-center font-small col-11 p-0">
              <img
                src={`${fileHandlerUrl}/icons/flags/${
                  currentCulture
                    ? `${currentCulture.toLowerCase()}.png`
                    : 'no_flag.png'
                }`}
                width={25}
                alt={``}
                className="  rounded-circle cursor-pointer "
                style={{ height: 20, width: 20 }}
              />
              {this.renderSearchAndLabel()}
            </div>
            <div className={'col-1 p-0 d-flex flex-end justify-content-end '}>
              {isOpenOption ? (
                <ChevronUpIcon color="#aaacaf" size={20} />
              ) : (
                <ChevronDownIcon color="#aaacaf" size={20} />
              )}
            </div>
          </div>
        </div>
        {this.renderOption()}
      </div>
    );
  }
}
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default connect(mapStateToProps)(CultureDropDown);
